<template>
  <!-- 热血盲盒管理-用户数据 -->
  <div class="battle_user_data-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="query.user_id"
            placeholder="请输入用户UID"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="user_id" label="用户id" align="center">
        </el-table-column>
        <el-table-column prop="user_name" label="用户名称" align="center">
        </el-table-column>
        <el-table-column prop="mhb_price" label="盲盒开箱金额" align="center">
        </el-table-column>
        <el-table-column
          prop="mhb_prize_price"
          label="盲盒奖品金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mhb_get_price"
          label="盲盒获得金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="profit"
          label="盈亏"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="mhb_total_price" label="总开箱金额" align="center">
        </el-table-column>
        <el-table-column
          prop="mhb_total_prize_price"
          label="总奖品金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mhb_total_get_price"
          label="盲盒获得金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="total_profit"
          label="总盈亏"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>

    <!-- 底部分页条 -->
    <el-pagination
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      :total="dataMeta ? dataMeta.total : 0"
      :current-page="dataMeta ? dataMeta.current_page : 1"
      :page-size="dataMeta ? dataMeta.per_page : 15"
      @current-change="handlLogPageChange"
    ></el-pagination>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  name: 'battle_user_data',
  data() {
    return {
      loading: false,//加载动画
      query: {
        page: 1,
        user_id: '',
        start_time: '',
        end_time: '',
      },
      dataList: [], //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('battle_user_data', params).then(res => {
        if (res) {
          this.dataList=[]
          this.dataList.push(res)
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
.battle_user_data-box {
  header {
  }

  .body-box {
  }
}
</style>